<template>
	<div>
		<div class="content">
			<div class="container help-center">
				<leftAbout></leftAbout>
				<div class="help-main">
					<h2>{{$namePc}}用户服务协议</h2>
          <iframe :src="content" style="border: none;width: 100%;height: 100%;display: block;min-height: 600px;"></iframe>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import leftAbout from '../common/about/index.vue'
  import config from '../../config'
	export default{
		data(){
			return{
        content:""
			}
		},
		components:{
			leftAbout
		},
    created(){
      this.getContent()
    },
    methods:{
      getContent(){
        this.$api.getContent({
          type:7
        })
        .then(result => {
          if(result.code === 1){
            this.content = config.founUrl + result.data.url
          }
        })
      }
    }
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/about/terrace.vue